<svg 
    [ngClass]="IconClass"
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">
    <path d="M8.5 0q1.445 0 2.473 0.73t1.027 1.77v7q0 1.016-0.98 1.734t-2.387 0.758l1.664 1.578q0.125 0.117 0.062 0.273t-0.234 0.156h-8.25q-0.172 0-0.234-0.156t0.062-0.273l1.664-1.578q-1.406-0.039-2.387-0.758t-0.98-1.734v-7q0-1.039 1.027-1.77t2.473-0.73h5zM6 10.5q0.625 0 1.062-0.438t0.438-1.062-0.438-1.062-1.062-0.438-1.062 0.438-0.438 1.062 0.438 1.062 1.062 0.438zM10.5 6v-4h-9v4h9z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-train.html